import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  goldMarketMap: "goldMarketMap [Action]",
  goldMarketMapLoading: "goldMarketMapLoading [Action]",
  goldMarketMapAsync: "goldMarketMapAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const goldMarketMapReducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.goldMarketMap:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.goldMarketMapLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.goldMarketMapLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "GOLD",
    method_type: "gold_market_map",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }

    yield put({
      type: actionTypes.goldMarketMap,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.goldMarketMapLoading,
      payload: false,
    });
  }
}

export function* goldMarketMap() {
  yield takeLatest(actionTypes.goldMarketMapAsync, handleWorker);
}
